module.exports = __webpack_public_path__ + "img/tech-12.5e1411de.jpg";